/**
 * Base Interface representing an entity of dire
 */
import { IAddress } from './address';

export interface IDire {
    name: string;
    code: string;
    address: IAddress;
    phone: string;
    selected: boolean;
}

export let emptyDire: IDire = {
    name: '',
    code: '',
    address: null,
    phone: '',
    selected: false,
};


// WEBPACK FOOTER //
// ./src/app/model/dire.ts